import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-tech bg-white py-5 sm:py-7" data-id="element-40" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-41" data-mp="844a752d8tdr">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-42" data-mp="m4ylpwkpnagn">
          ONE LAST <span className="text-tech" data-id="element-43" data-mp="m2ltmql8njpv">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-steel sm:text-base" data-id="element-44" data-mp="h52dfl4zcwva">
          <p data-id="element-45" data-mp="vtyprue2kw1p">
            When you're assessing patients, reviewing IV procedures, evaluating wounds, checking
            medication safety, monitoring bedside equipment, or recognizing emergency warning
            signs...
          </p>
          <p data-id="element-46" data-mp="zwvabqn6728a">
            Do you have one organized visual reference system that brings these essential nursing
            clinical skills together?
          </p>
          <p data-id="element-47" data-mp="2c6rbe9i74gon">
            Stop relying entirely on scattered textbooks, disconnected procedure diagrams, and
            endless searches for nursing references.
          </p>
          <p data-id="element-48" data-mp="2m19fvgvfsg9i">
            <strong className="font-semibold text-navy" data-id="element-49" data-mp="2m1j9rfjlr7kh">
              See the procedures. Understand the assessments. Organize your clinical references.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-50" data-mp="2v1g1jq1agmjr" />

        <div className="mt-2 text-center" data-id="element-51" data-mp="3023p21qb6l98">
          <p className="font-heading text-xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-52" data-mp="3010xdrl5wes9">
            🩺 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-steel sm:text-base" data-id="element-53" data-mp="39s5eawuee9pq">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-2xs font-bold uppercase tracking-wide text-teal sm:text-sm" data-id="element-54" data-mp="3it3awu2ibeya">
            Assess • Visualize • Verify • Monitor • Recognize • Document
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-55" data-mp="1epihxjr7dpg4">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-56" data-mp="1er3bb61s72ce">
            🔥 GET THE COMPLETE SYSTEM TODAY — <span className="text-tech" data-id="element-57" data-mp="1novsyguz6m2y">$27 USD</span>
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-58" data-mp="22eur4jmj5xif">🩺 GET {PRODUCT}</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-59" data-mp="22d04n0vm1xc8" />
        </div>
      </div>
    </section>;
}